var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PersonaError } from '../error';
import { EventEmitter } from '../event-emitter';
import AudioPlayer from './audio-player';
import AudioRecorder from './audio-recorder';
var AudioQueueManager = (function (_super) {
    __extends(AudioQueueManager, _super);
    function AudioQueueManager() {
        var _this = _super.call(this) || this;
        _this.AudioPlayer = new AudioPlayer();
        _this.AudioRecorder = new AudioRecorder();
        return _this;
    }
    AudioQueueManager.prototype.enqueue = function (arrayBuffer) {
        if (!this._canAIAcceptNewInput) {
            throw new PersonaError('AUDIO_QUE', 'AI cannot accept new input at this time');
        }
        this.AudioPlayer.audioQueue.push(arrayBuffer);
    };
    AudioQueueManager.prototype._setCanAIAcceptNewInput = function (can) {
        this._canAIAcceptNewInput = can;
    };
    AudioQueueManager.prototype.canAIAcceptNewInput = function () {
        return this._canAIAcceptNewInput;
    };
    AudioQueueManager.prototype.playAudio = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.AudioPlayer.playAudio()];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        error_1 = _a.sent();
                        throw error_1;
                    case 3: return [2];
                }
            });
        });
    };
    AudioQueueManager.prototype.initializeChat = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.AudioPlayer._initializeAudio();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.AudioRecorder._initializeAudioRecorder()];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        error_2 = _a.sent();
                        throw error_2;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4, this.AudioPlayer._initializeAudioPlayer()];
                    case 5:
                        _a.sent();
                        return [3, 7];
                    case 6:
                        error_3 = _a.sent();
                        throw error_3;
                    case 7:
                        this.registerRecorderListeners();
                        this.registeredPlayerListeners();
                        return [2];
                }
            });
        });
    };
    AudioQueueManager.prototype.startChatting = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.AudioRecorder._startRecording ||
                    !this.AudioPlayer._startPlaying) {
                    throw new PersonaError('AUDIO_QUE', 'Chat not initialized. Please call "initializeChat" first.');
                }
                this.AudioRecorder._startRecording();
                this.AudioPlayer._startPlaying();
                return [2];
            });
        });
    };
    AudioQueueManager.prototype.stopChatting = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.AudioRecorder._stopRecording || !this.AudioPlayer._stopPlaying) {
                            throw new PersonaError('AUDIO_QUE', 'Chat not initialized. Please call "initializeChat" first.');
                        }
                        return [4, this.AudioRecorder._stopRecording()];
                    case 1:
                        _a.sent();
                        return [4, this.AudioPlayer._stopPlaying()];
                    case 2:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    AudioQueueManager.prototype.stopAISpeech = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._setCanAIAcceptNewInput(false);
                        return [4, this.AudioPlayer._stopPlaying(false)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    AudioQueueManager.prototype.restartAISpeech = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                this._setCanAIAcceptNewInput(true);
                if (!((_a = this.AudioPlayer) === null || _a === void 0 ? void 0 : _a.isAISpeaking())) {
                    this.AudioPlayer._startPlaying();
                }
                return [2];
            });
        });
    };
    AudioQueueManager.prototype.registerRecorderListeners = function () {
        var _this = this;
        this.AudioRecorder.on('UserSpeechChunk', function (chunk) {
            _this.emit('UserSpeechChunk', chunk);
        });
    };
    AudioQueueManager.prototype.registeredPlayerListeners = function () {
        var _this = this;
        this.AudioPlayer.on('ai_speech_amplitude', function (amplitude) {
            _this.emit('ai_speech_amplitude', amplitude);
        });
    };
    return AudioQueueManager;
}(EventEmitter));
export default AudioQueueManager;
